import styled from 'styled-components'

export const VersionsSectionContainer = styled.div`
  margin-bottom: 20px;
`

export const VersionsTopSection = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
`
